function PtoRulesMixin() {}

PtoRulesMixin.prototype.cellGeneralClassName = "ptoRulesCell";
PtoRulesMixin.prototype.getBalanceFromCellValue = function(value) {
    return value.currentPTOBalance;
};

export default PtoRulesMixin



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/PtoRulesMixin.js